<template>
  <div>
    <a-modal v-model="visible" :title="$t('序列号详情')" :destroyOnClose="true" :footer="null" @cancel="$emit('cancel', false)">
      <a-table rowKey="id" size="small" :columns="columns" :dataSource="dataItems" :pagination="false" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: ["visible", "items"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      dataItems: [],
      columns: [
        {
          title: this.$t("序号"),
          dataIndex: "index",
          width: 60,
          customRender: (value, item, index) => index + 1,
        },
        {
          title: this.$t("序列号"),
          dataIndex: "serial_number",
        },
      ],
    };
  },
  methods: {},
  watch: {
    visible(status) {
      if (status) {
        this.dataItems = this.items.map((value) => ({ serial_number: value }));
      }
    },
  },
};
</script>

<style scoped></style>
